import { request } from "common/components/request";
import {
    CannotConnectToAPI,
    MaintenanceMode,
    ConfigError
} from "common/helpers/errors";

import strings from "common/strings";

import {
    SET_APP_CONFIG,
    INIT_SENTRY,
    CONFIGURE_TRACKING,
    SET_API_VERSION
} from "common/actions/config";

import { DEBUG_LISTENERS } from "common/actions/settings";

import "extensions/fa5-icons/";
import "extensions/bootstrap";
import "sass/styles.scss";

// Create globals
window.strings = strings;
window.webix_strict = true;

DEBUG_LISTENERS();

export const setConfig = async function() {
    let configData;
    try {
        // eslint-disable-next-line import/no-unresolved
        const { "default": staticJsonConfig } = await import("config.json"); /* webpackChunkName: "config" */
        configData = staticJsonConfig;
    } catch {
        throw new ConfigError("Config is not present");
    }
    
    SET_APP_CONFIG(configData);
    CONFIGURE_TRACKING();
    INIT_SENTRY();
};

export const checkApiHealth = () => request("/version", {
    ensureAuth: false,
    preventPreFlight: true
}).then(({ version }) => {
    SET_API_VERSION(version);
}).catch((error) => {
    // Show maintenance page when API reports back 503 status code
    if (error.response.status === 503) {
        throw new MaintenanceMode();
    }
    
    throw new CannotConnectToAPI({
        message: error.response
            ? `Cannot connect to the API: ${error.response.statusText} (code ${error.response.status})`
            : "Cannot connect to the API: Network error"
    });
});

export const healthcheck = () => request("/healthcheck", {
    ensureAuth: false,
    preventPreFlight: true
})
    .then((response) => JSON.stringify({ ...response, status: 200 }))
    .catch((error) => {
        if (error.response.status === 503) {
            // When either the pipeline or ui database are down the response is 503
            return JSON.stringify({
                ...error.response.body,
                status: 503
            });
        }
        // The API response should always come through, so this is an unexpected case.
        return JSON.stringify(error);
    });
